import { Bank, Clock } from '@hourly-hds/icons/colored';
import { ComponentType } from 'react';
import styles from './BankAccount.module.css';

export type VerificationStatus = 'Idle' | 'Pending' | 'Successfully';

interface BankAccountCardProps {
  verificationStatus: VerificationStatus;
}

const Idle = () => (
  <div className={styles.idleIconContainer} aria-label="Bank Account Not Connected">
    <Bank color="#fe3824" />
  </div>
);

const Pending = () => (
  <div className={styles.iconContainer} aria-label="Bank Account Pending Verification">
    <Clock color="#F5A623" />
    <span className={styles.text}>
      Bank Account <br />
      <span className={styles.pendingLabel}>Pending</span> Verification
    </span>
  </div>
);

const Successfully = () => (
  <div className={styles.iconContainer} aria-label="Bank Account Successfully Added">
    <Clock color="#0076ff" />
    <span className={styles.text}>
      Bank Account
      <br />
      <span className={styles.successfullyLabel}>Successfully</span> Added
    </span>
  </div>
);

const bankVerificationMap: Record<VerificationStatus, ComponentType> = {
  Idle,
  Successfully,
  Pending,
};

const BankAccountCard = ({ verificationStatus }: BankAccountCardProps) => {
  const BankVerificationStatus = bankVerificationMap[verificationStatus] || Idle;

  return (
    <div className={styles.container}>
      <BankVerificationStatus />
    </div>
  );
};

export default BankAccountCard;
